export const ITEMS_POR_COLUNA = 2;
